import path from "path";
import {app, storage, fs} from "./electron-modules";
import manifest from "../package.json";

const changeDuplicateNames = (projections) => {
  const projectionsByName = {};

  projections.forEach((projection) => {
    if (!projectionsByName[projection.name]) {
      projectionsByName[projection.name] = 2;
    } else {
      const newName = `${projection.name} (${projectionsByName[projection.name]})`;
      projectionsByName[projection.name]++;
      projection.name = newName;
    }
  });
};

export const setStoragePath = (userSettings, isStaticSite) => {
  if (isStaticSite) return;

  const storagePath = path.join(app.getPath('appData'), 'SOLV3D Data');
  const engineStoragePath = path.join(app.getPath('appData'), `${manifest.workflowName}/storage`);
  const viewerStoragePath = path.join(app.getPath('appData'), `${manifest.productName}/storage`);

  if (!fs.existsSync(storagePath)) {
    fs.mkdirSync(storagePath);
  }

  for (const settingName of userSettings) {
    let oldName = path.join(viewerStoragePath, `${settingName}.json`);
    let newName = path.join(storagePath, `${settingName}.json`);
    if (fs.existsSync(oldName) && !fs.existsSync(newName)) {
      fs.copyFileSync(oldName, newName);
    }
  }
  if (fs.existsSync(path.join(storagePath, 'user-projections.json'))) {
    storage.setDataPath(storagePath);
    return;
  }

  const engineProjectionExist = fs.existsSync(path.join(engineStoragePath, 'user-projections.json'));
  const viewerProjectionExist = fs.existsSync(path.join(viewerStoragePath, 'projection.json'));

  let projectionData = [];
  if (viewerProjectionExist) {
    projectionData = [
      ...projectionData,
      ...storage.getSync('projection', {dataPath: viewerStoragePath})];
  }
  if (engineProjectionExist) {
    let engineProjections = storage.getSync('user-projections', {dataPath: engineStoragePath});
    Object.keys(engineProjections).forEach((key) => {
      let data = engineProjections[key];
      if ('transform' in data) {
        data.transform = {
          origin: data.transform.origin,
          translation: data.transform.translation,
          rotation: data.transform.rotation,
          scale: data.transform.scale
        };
      }
      let finalData = {type: 'proj4', name: key, ...data};
      projectionData.push(finalData);
    });
  }
  if (viewerProjectionExist && engineProjectionExist) {
    changeDuplicateNames(projectionData);
  }
  storage.setDataPath(storagePath);
  storage.setSync('user-projections', projectionData);
};
